import { useQuery } from '@tanstack/react-query'
import ActivityLog from '../../model/ActivityLog'
import { dataSource } from '../../service/domain/_service.config'
import { useChallengeAccess } from '../membership/useChallengeAccess'

export const ACTIVITY_LOGS_QUERY_KEY = (teamID: string) => ['activityLogs', teamID] as const

export function useActivityLogs(teamID?: string) {
  const { teamID: activeTeamID } = useChallengeAccess()
  const resolvedTeamID = teamID || activeTeamID

  return useQuery<ActivityLog[]>({
    queryKey: ACTIVITY_LOGS_QUERY_KEY(resolvedTeamID),
    queryFn: () => {
      if (!resolvedTeamID) throw new Error('User has no team')
      return dataSource.getActivityLogs(resolvedTeamID)
    },
    enabled: !!resolvedTeamID,
  })
}
